<div *ngIf="formVisible">
  <div class="filter-container">
    <form>
      <div class="title">
        <label for="active-filter">Active:</label>
      </div>

      <button class="apply-filter-btn" (click)="apply()">Apply</button>
    </form>
  </div>
</div>
